import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-31bc1c4b")

_pushScopeId("data-v-31bc1c4b")
const _hoisted_1 = { class: "js-loading-section l-loading" }
const _hoisted_2 = { class: "loading__tl" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "linear-activity" }, [
  /*#__PURE__*/_createVNode("div", { class: "indeterminate" })
], -1)
const _hoisted_4 = { class: "loading__dc" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('loading.title')), 1),
    _hoisted_3,
    _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('loading.text')), 1)
  ]))
})